import ApplicationSerializer from './application';

export default class QuestionnaireResponseSerializer extends ApplicationSerializer {
  serializeBelongsTo(snapshot, json, relationship) {
    super.serializeBelongsTo(snapshot, json, relationship);

    let key = relationship.key;
    let belongsTo = snapshot.belongsTo(key);
    if (belongsTo.modelName === 'invite') {
      json['relationships'][key]['data']['id'] = belongsTo.attr('inviteId');
    }
  }
}
